import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { myPageService } from 'shared/src/api';

export const useAlarmSettings = () => {
  return useSuspenseQuery({
    queryKey: queryKey.alarmSettings(),
    queryFn: () => myPageService.getAlarmSettings(),
  });
};
